module.exports = __webpack_public_path__ + "static/media/undermaintenance-icon.49792704.svg";